<template>
    <div>
      <div v-if="loading" class="text-center p-5">Loading youtube...</div>
  
      <div v-else>
        <div v-if="yt.length === 0" class="text-center text-muted p-4 border rounded">
          No youtube available.
        </div>
  
        <table class="table">
          <thead>
            <tr>
              <th>Title / Link</th>
              <th>Date</th>
              <th class="text-right">Action</th>
            </tr>
          </thead>
          <tbody>
  <tr>
    <td>{{ yt.Link }}</td>
    <td>{{ formatDate(yt.CreatedTime) }}</td>
    <td>
      <div class="d-flex justify-content-end align-items-center gap-2">
        <img
          src="../../assets/img/edit-btn.png"
          width="30"
          class="mr-1 cursor-pointer"
          @click="openEditYoutube(yt)"
        />
        <img
          src="../../assets/img/delete-btn.png"
          width="30"
          class="cursor-pointer"
          @click="deleteYoutube(yt.Id)"
        />
      </div>
    </td>
  </tr>
</tbody>
        </table>
      </div>
  
      <!-- ✏️ Edit Popup -->
      <div v-if="openYoutube" class="upload-popup-overlay" @click.self="closeYoutube">
      <div class="upload-popup-card">
        <button class="close-btn" @click="closeYoutube">×</button>
        <h4 class="popup-title text-left">Edit Youtube</h4>

        <div class="text-left mt-4">
          <label>URL Video Youtube</label>
          <CInput
            v-model="youtubeUrl"
            type="text"
            placeholder="Masukkan URL lengkap dari video YouTube"
          />
          <small class="text-muted">Masukkan URL lengkap dari video YouTube</small>
        </div>

        <div class="d-flex justify-content-end mt-4">
          <CButton color="secondary" class="custom-btn-grey text-dark m-1" @click="closeYoutube">
            Cancel
          </CButton>
          <CButton color="primary" class="btn-modern m-1" @click="saveYoutube">
            Simpan
          </CButton>
        </div>
      </div>
    </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "YoutubeListPopup",
    data() {
      return {
        yt: [],
      loading: false,
      openYoutube: false,
      selectedYoutubeId: null,
      youtubeUrl: "",
      };
    },
    async mounted() {
      this.GetYoutube();
    },
    methods: {
      formatDate(dateStr) {
        if (!dateStr) return "-";
        const d = new Date(dateStr);
        return d.toLocaleDateString("en-MY", {
          year: "numeric",
          month: "short",
          day: "numeric",
        });
      },
  
      async GetYoutube() {
        this.loading = true;
        try {
          const response = await this.$API.get(this.$GetListYoutube);
          if (response.status === 200) {
            this.yt = response.data;
          }
        } finally {
          this.loading = false;
        }
      },
  
      // ✏️ Open edit popup
      openEditYoutube(item) {
  this.selectedYoutubeId = item.Id; // match backend
  this.youtubeUrl = item.Link;
  this.openYoutube = true;
},

    // ✏️ Close popup
    closeYoutube() {
      this.openYoutube = false;
      this.selectedYoutubeId = null;
      this.youtubeUrl = "";
    },

    async saveYoutube() {
  if (!this.youtubeUrl) return alert("Please enter a YouTube URL");

  try {
    const formData = new FormData();
    formData.append("Id", this.selectedYoutubeId || 0); // 0 = new
    formData.append("Link", this.youtubeUrl);
    formData.append("Status", true); // or your desired status

    await this.$API.post(this.$InsertYoutube, formData, {
      withCredentials: true,
    });

    alert("✅ YouTube link updated successfully!");
    this.closeYoutube();
    this.GetYoutube();
  } catch (err) {
    console.error(err);
    alert("⚠️ Failed to update YouTube link.");
  }
},

    // 🗑️ Delete YouTube
    async deleteYoutube(id) {
      if (!confirm("Are you sure you want to delete this YouTube link?")) return;
      try {
        await this.$API.post(this.$DeleteYoutube, { id }, { withCredentials: true });
        alert("✅ YouTube link deleted successfully!");
        this.GetYoutube();
      } catch (err) {
        console.error(err);
        alert("⚠️ Failed to delete YouTube link.");
      }
    },
    },
  };
  </script>
  
  <style scoped>
  .cursor-pointer {
    cursor: pointer;
  }
  </style>